import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AppleDevice } from '@era/locations-sdk';
import { ConfigurationProfile } from '@rocksoft/mdm-sdk-v2';

import {
  AppleDeviceStoreActions,
  AppleProfilesStoreActions,
  DevicesRouterStoreSelectors,
  RouterStoreStates,
} from '@era/stores';

@Injectable()
export class AppleDeviceResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly appleDeviceStore: Store<AppleDevice>,
    private readonly appleProfileStore: Store<ConfigurationProfile>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.appleDeviceStore.dispatch(
          AppleDeviceStoreActions.AppleDeviceContainerActions.appleDeviceRequested({ udid })
        );
        this.appleProfileStore.dispatch(
          AppleProfilesStoreActions.AppleDeviceResolverActions.profilesRequested({ udid })
        );
      }),
      map(() => true),
      first()
    );
  }
}
